import React from 'react';

import MsgScreen from '../../@packages/@bd-uikit-web/React/MsgScreen';
import NotiBanner from '../../@packages/@bd-uikit-web/React/NotiBanner';
import { connect } from 'react-redux';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';


import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';
import store from 'store';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';

export class App extends React.Component {

  constructor() {
    super();

    this.state = {
      user: bdAuth.getUser() || {},
      loading: true,
      submitting: false,
      showArtworkNotAvailableModal: false,
      showSubscribeModal: false,
      showNoticeBar: true,
      open: false,
    };
    this.networkExitTimeout
  }

  componentDidMount() {
    webapis.network.addNetworkStateChangeListener(function (value) {
      if (value == webapis.network.NetworkState.GATEWAY_DISCONNECTED) {
        // Something you want to do when network is disconnected
        this.props.history.push('/error');

        this.networkExitTimeout = setTimeout(() => { tizen.application.getCurrentApplication().exit(); }, 7000);
      } else if (value == webapis.network.NetworkState.GATEWAY_CONNECTED) {
        // Something you want to do when network is connected again
        clearTimeout(this.networkExitTimeout);
      }
    });

    webapis.appcommon.setScreenSaver(webapis.appcommon.AppCommonScreenSaverState.SCREEN_SAVER_OFF, this.onsuccess, this.onerror);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        console.log("App Hidden");
        let video = document.getElementById("video");
        if (video != null) {
          video.pause();
        }
        this.props.history.push('/');
        // Same behavior as "Return" key click
        // For example, stop playback and return to previous page
      } else {
        console.log("App Visible");
        if (video != null) {
          video.play();
        }
        // store.set("video", "change");
        // Behavior when application is resumed
      }
    });
    tizen.tvinputdevice.registerKey("Exit");
  }

  render() {
    return (
      <div className="full-size" onKeyUp={this.handleEvent}>
        {this.state.showNoticeBar ? <NotiBanner /> : null}
        {
          this.props.children
        }
      </div>
    );
  }
}

export default connect((state) => {
  const { history } = state;
  return {
    history
  }
})(App);
